import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.13.1_@parcel+watcher@2.4.1_@types+node@22.7.4_eslint@8.57.0_ioredis@5.4.1_magicast@0.3_nhq22ea2h6es77xgdwmliv67re/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}